import styled from 'styled-components';
import { brand } from 'themes/brand';

export const Container = styled.section<{ height?: string; width?: string }>`
  background: ${brand.white};
  border: 1px solid ${brand.border};
  box-shadow: ${brand.cardShadow};
  border-radius: 10px;
  width: ${({ width }) => width};
  height: ${({ height }) => height};
  padding: 40px 30px;
`;
